import { BetaTag } from 'components';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import styles from './recommendedBadge.module.scss';

export const RecommendedBadge = () => {
    return (
        <BetaTag
            containerClassName={styles['beta-tag']}
            tagMessage={<FormattedMessage id="app.recommended" defaultMessage="Recommended" />}
            tooltipMessage=""
        />
    );
};
